// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssai-monitoring-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: calc(100vh - 100px);
  border-radius: 15px;
  color: #333;
}

.ssai-monitoring-container .header h2 {
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}

.status-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: none;
}

.status-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
}

.metric-box {
  transition: background-color 0.3s ease;
}

.metric-box:hover {
  background-color: #e9ecef !important;
}

.card {
  border: none;
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  border-bottom: 1px solid rgba(0,0,0,0.05) !important;
  font-weight: 600;
  color: #444;
}

.alert {
  border-left: 4px solid;
  border-radius: 4px;
}

.alert-critical {
  background-color: #f8d7da;
  border-color: #dc3545;
  color: #721c24;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffc107;
  color: #856404;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #17a2b8;
  color: #0c5460;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(359deg); }
}

.metric-box .h4 {
  color: #2c3e50;
  font-weight: 700;
}

.list-group-item {
  border-left: none;
  border-right: none;
  padding: 12px 15px;
}

.ssai-monitoring-container .footer {
  font-size: 0.8rem;
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/ssai-monitoring.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".ssai-monitoring-container {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: calc(100vh - 100px);\n  border-radius: 15px;\n  color: #333;\n}\n\n.ssai-monitoring-container .header h2 {\n  font-weight: 700;\n  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);\n}\n\n.status-card {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: none;\n}\n\n.status-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;\n}\n\n.metric-box {\n  transition: background-color 0.3s ease;\n}\n\n.metric-box:hover {\n  background-color: #e9ecef !important;\n}\n\n.card {\n  border: none;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.card-header {\n  border-bottom: 1px solid rgba(0,0,0,0.05) !important;\n  font-weight: 600;\n  color: #444;\n}\n\n.alert {\n  border-left: 4px solid;\n  border-radius: 4px;\n}\n\n.alert-critical {\n  background-color: #f8d7da;\n  border-color: #dc3545;\n  color: #721c24;\n}\n\n.alert-warning {\n  background-color: #fff3cd;\n  border-color: #ffc107;\n  color: #856404;\n}\n\n.alert-info {\n  background-color: #d1ecf1;\n  border-color: #17a2b8;\n  color: #0c5460;\n}\n\n.fa-spin {\n  animation: fa-spin 2s infinite linear;\n}\n\n@keyframes fa-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(359deg); }\n}\n\n.metric-box .h4 {\n  color: #2c3e50;\n  font-weight: 700;\n}\n\n.list-group-item {\n  border-left: none;\n  border-right: none;\n  padding: 12px 15px;\n}\n\n.ssai-monitoring-container .footer {\n  font-size: 0.8rem;\n  padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
